import * as CSS from './error-page.scss';

export const showDefaultErrorPage = (): void => {
	const body = document.getElementsByTagName('body')[0];

	const containerDiv = document.createElement('div');
	containerDiv.id = 'error-container';
	containerDiv.classList.add(CSS.Container);
	containerDiv.style.height = `${window.innerHeight}px`;
	containerDiv.style.minHeight = '-webkit-fill-available';

	const innerDiv = document.createElement('div');
	innerDiv.classList.add(CSS.FlexColumn);
	const text = document.createElement('div');
	// text.classList.add(CSS.ErrorText);
	text.textContent = 'Oops! Something went wrong.';
	const reloadButton = document.createElement('button');
	reloadButton.textContent = 'Try again';
	reloadButton.addEventListener('click', () => {
		window.location.reload();
		reloadButton.innerText = 'Reloading...';
	});

	innerDiv.appendChild(text);
	innerDiv.appendChild(reloadButton);
	containerDiv.appendChild(innerDiv);
	body.appendChild(containerDiv);
};
